<template>
  <div class="v2-table-wrap">
    <table class="v2-table">
      <thead>
        <tr>
          <th>Kennzahl</th>
          <th>IST</th>
          <th>Plan</th>
          <th>VS Plan</th>
          <th>Vorjahr</th>
          <th>VS Vorjahr</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in visibleRows"
          :key="row.key"
          :class="[
            `v2-table__row--level-${row.level}`,
            { 'v2-table__row--expandable': row.expandable },
            { 'v2-table__row--expanded': row.expandable && expandedKeys[row.key] },
          ]"
          @click="row.expandable ? toggle(row.key) : null"
        >
          <td class="v2-table__name">
            <span class="v2-table__name-inner" :style="{ paddingLeft: row.level * 16 + 'px' }">
              <span
                v-if="row.expandable"
                class="v2-table__toggle"
                :class="{ 'v2-table__toggle--open': expandedKeys[row.key] }"
              >▶</span>
              <span v-else class="v2-table__toggle v2-table__toggle--placeholder">▶</span>
              <span>{{ row.name }}</span>
            </span>
          </td>
          <td>{{ row.ist }}</td>
          <td>{{ row.plan }}</td>
          <td class="v2-table__delta" :class="row.vsPlanClass">{{ row.vsPlan }}</td>
          <td>{{ row.vj }}</td>
          <td class="v2-table__delta" :class="row.vsVjClass">{{ row.vsVj }}</td>
        </tr>
        <tr v-if="rows.length === 0">
          <td colspan="6" class="v2-table__empty">Keine Kennzahlen verfügbar.</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    rows: { type: Array, default: () => [] }
  },
  data() {
    return { expandedKeys: {} };
  },
  computed: {
    visibleRows() {
      return this.rows.filter(row => {
        if (!row.parentKey) return true;
        if (!this.expandedKeys[row.parentKey]) return false;
        // For level-2 rows also check grandparent
        if (row.level >= 2) {
          const parent = this.rows.find(r => r.key === row.parentKey);
          if (parent && parent.parentKey && !this.expandedKeys[parent.parentKey]) return false;
        }
        return true;
      });
    },
  },
  methods: {
    toggle(key) {
      this.expandedKeys = { ...this.expandedKeys, [key]: !this.expandedKeys[key] };
    },
  },
};
</script>

<style scoped>
/* Ergebnistabelle als Jira-Liste (ADS): Kopf ohne Versalien, 40-px-Zeilen, aufklappbar. */
.v2-table-wrap {
  overflow-x: auto;
}
.v2-table {
  width: 100%;
  border-collapse: collapse;
  background: var(--ds-surface);
}
.v2-table th,
.v2-table td {
  padding: 6px 16px;
  border-bottom: 1px solid var(--ds-border);
  font-size: 14px;
}
.v2-table th {
  padding: 8px 16px;
  border-bottom-width: 2px;
  color: var(--ds-text-subtle);
  font-size: 12px;
  font-weight: 700;
  text-align: left;
}
.v2-table td {
  height: 40px;
}
.v2-table td:nth-child(n + 2),
.v2-table th:nth-child(n + 2) {
  text-align: right;
  font-variant-numeric: tabular-nums;
}
.v2-table tbody tr:hover td {
  background: var(--ds-surface-hovered);
}
.v2-table__delta {
  white-space: pre-line;
  line-height: 1.3;
}
/* Ebenen */
.v2-table__row--level-0 td { font-weight: 600; }
.v2-table__row--level-1 td { font-weight: 500; }
.v2-table__row--level-2 td { font-weight: 400; font-size: 13px; color: var(--ds-text-subtle); }
/* Aufklappen */
.v2-table__row--expandable { cursor: pointer; }
.v2-table__name-inner { display: inline-flex; align-items: center; gap: 6px; }
.v2-table__toggle {
  display: inline-block;
  font-size: 0.55rem;
  color: var(--ds-text-subtlest);
  transition: transform 0.15s;
  flex-shrink: 0;
}
.v2-table__toggle--open { transform: rotate(90deg); }
.v2-table__toggle--placeholder { visibility: hidden; }
.positive { color: var(--ds-success-text) !important; }
.negative { color: var(--ds-danger-text) !important; }
.v2-table__empty {
  text-align: center;
  color: var(--ds-text-subtlest);
  font-style: italic;
  background: var(--ds-surface-sunken);
}
</style>
